import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SurveyContextDataDisplay from 'Views/Onboarding/Pages/Survey/SurveyContextDataDisplay';
import RefreshAccountsIndicator from 'Views/Onboarding/Pages/Survey/SurveyContentBody/RefreshAccountsIndicator';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import {
  isDigitalOnboardingStepContentDrivenByLayout,
} from 'Views/Onboarding/Pages/Survey/SurveyContentPicker/SurveyContent';
import SurveyStep from '../SurveyStep';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '100%',
    padding: theme.spacing(0, 2),
  },
  rootNoPadding: {
    padding: 0,
  },
  rootWithFixedFooter: {
    marginBottom: theme.spacing(20), // <--- IN PLACE TO PUSH CONTENT AWAY FROM THE STICKY BOTTOM NAV BAR
  },
  refreshIndicator: {},
});

const SurveyContentBody = ({
  className,
  classes,
}) => {
  const {
    fixedFooter,
    showFooter,
    onboardingStepResource,
  } = useSurveyContext();

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootWithFixedFooter]: showFooter && fixedFooter,
        [classes.rootNoPadding]: isDigitalOnboardingStepContentDrivenByLayout(onboardingStepResource),
      })}
    >
      <RefreshAccountsIndicator
        className={classes.refreshIndicator}
      />
      <SurveyContextDataDisplay />
      <SurveyStep />
    </Box>
  );
};

SurveyContentBody.defaultProps = {
  className: '',
};

SurveyContentBody.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyContentBody);
